import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, LayoutGap } from '@gov-nx/ui/web';
import {
	generateRandomNumber,
	generateArrayFromLength,
} from '@gov-nx/utils/common';

export const NotificationsSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap>
			<ContentLayout>
				{generateArrayFromLength(5).map((i) => (
					<div
						className="flex flex-col py-6 pl-6 mt-0! border-b border-(--border-subtlest) [ last-of-type:border-0 ] [ md:justify-between md:flex-row ]"
						key={i}>
						<div className="w-full">
							<GovSkeleton
								width={generateRandomNumber(50, 90) + '%'}
								height="22px"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
								className="ml-5"
							/>
							<GovSkeleton
								width={generateRandomNumber(50, 90) + '%'}
								height="22px"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
								className="ml-5 mb-2 [ md:hidden ]"
							/>
						</div>
						<GovSkeleton
							width="120px"
							height="22px"
							aria-label={t('loading.wcag.processing', {
								namespace: LocalizeNameSpaceTypes.Global,
							})}
							className="ml-5"
						/>
					</div>
				))}
			</ContentLayout>
		</LayoutGap>
	);
};
